// Durations, percentages and multiples as the calculators write them, in
// lockstep with the Rust that renders the same numbers before this runs. The
// page ships the duration-*, percent and multiple* messages.
import { number, t } from "./_i18n.js";

// Sub-second falls to ms, under ten seconds keeps one decimal, larger values
// break into days, hours, minutes and seconds.
export function humanDuration(secs) {
  if (!(secs > 0)) return t("duration-seconds", { n: 0 });
  if (secs < 1) return t("duration-ms", { n: Math.round(secs * 1000) });
  if (secs < 10) {
    const v = Math.round(secs * 10) / 10;
    const n = Number.isInteger(v) ? v : number(v, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return t("duration-seconds", { n });
  }
  let total = Math.round(secs);
  const d = Math.floor(total / 86_400);
  total %= 86_400;
  const h = Math.floor(total / 3_600);
  total %= 3_600;
  const m = Math.floor(total / 60);
  const s = total % 60;
  return [
    ["duration-days", d],
    ["duration-hours", h],
    ["duration-minutes", m],
    ["duration-seconds", s],
  ]
    .filter(([, n]) => n > 0)
    .map(([id, n]) => t(id, { n }))
    .join(" ");
}

// Up to `digits` decimals, trailing zeros dropped, in the page's decimal mark.
function trimmed(n, digits) {
  return number(parseFloat(n.toFixed(digits)), { maximumFractionDigits: digits, useGrouping: false });
}

export function percent(pct, digits = 4) {
  return t("percent", { value: trimmed(pct, digits) });
}

export function multiple(rate) {
  if (!Number.isFinite(rate)) return t("multiple-infinite");
  return t("multiple", { value: trimmed(rate, 2) });
}
